if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
(function() {
    let bundleSize = document.querySelectorAll('.bundle-sidebar__items .bundle-item').length;
    let bundleItemRemoveButton = `<button type="button" class="button remove icon-fallback-text" aria-label="remove from bundle">
<svg  aria-hidden="true" focusable="false" role="presentation" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

    </button>`;
    window.selectedProducts = [];

    let changeButtonText = function(qty) {
        let title = document.querySelector('.bundle-sidebar__bottom-title');
        if (qty > 0) {
            title.textContent = `Select ${bundleSize - qty} more flavors`;
        } else {
            title.textContent = `Select ${bundleSize} flavors`;
        }
    };

    let productsAddedTotal = 0;

    function addProduct(context) {
        let selectedProduct = context.closest('.bundle-product');
        let productId = selectedProduct.dataset.productId;
        let productTitle = selectedProduct.dataset.productTitle;
        let selectedProductImg = selectedProduct.querySelector('img').cloneNode(true);
        let fillableItem = document.querySelector('.bundle-item:not(.added)');
        let qty = parseInt(selectedProduct.querySelector('.js-qty__num').value);

        if (!fillableItem) return;
        
        fillableItem.setAttribute('data-id', productId);
        fillableItem.insertAdjacentHTML("afterbegin", bundleItemRemoveButton);
        fillableItem.querySelector('.bundle-item__inner').appendChild(selectedProductImg);
        fillableItem.querySelector('.bundle-item__title').textContent = productTitle;
        fillableItem.classList.add('added');

        let productIndex = window.selectedProducts.findIndex(item => item.id === productId);
        if (productIndex !== -1) {
            window.selectedProducts[productIndex].qty = qty;
        } else {
            window.selectedProducts.push({ id: productId, title: productTitle, qty: qty });
        }

        productsAddedTotal++;
        if (productsAddedTotal === bundleSize) {
            document.querySelector('.bundle-sidebar__main .AddToCart').setAttribute('aria-hidden', 'false');
            document.querySelector('.bundle-sidebar__main .bundle-sidebar__bottom-title').setAttribute('aria-hidden', 'true');
            document.querySelectorAll('.qty-select').forEach(el => el.setAttribute('disabled', 'true'));
        }

        changeButtonText(productsAddedTotal);
    }

    function onProductRemove() {
        productsAddedTotal--;
        let newBundleItem = document.createElement('div');
        newBundleItem.classList.add('bundle-item');
        newBundleItem.innerHTML = '<div class="bundle-item__inner"></div><div class="bundle-item__title"></div>';
        document.querySelector('.bundle-sidebar__items').appendChild(newBundleItem);

        if (productsAddedTotal !== bundleSize) {
            document.querySelector('.bundle-sidebar__main .AddToCart').setAttribute('aria-hidden', 'true');
            document.querySelector('.bundle-sidebar__main .bundle-sidebar__bottom-title').setAttribute('aria-hidden', 'false');
            document.querySelectorAll('.qty-select').forEach(el => el.removeAttribute('disabled'));
        }
        changeButtonText(productsAddedTotal);
    }

    let itemAddedCallback = function (product) {

    };

    document.querySelector('.bundle-sidebar__main .AddToCart').addEventListener('click', function () {
        let properties = window.selectedProducts.reduce((accumulator, item, index) => {
            let key = `Flavor ${index + 1}`;
            return { ...accumulator, [`${key}`]: `${item.title} x ${item.qty}` };
        }, {});

        const formData = new FormData();

        formData.append("items[0][quantity]", "1");
        formData.append("items[0][id]", document.querySelector(".bundle-products").dataset.id);

        Object.keys(properties).forEach((key, index) => {
            formData.append(`items[0][properties][${key}]`, properties[key]);
        });

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        if (cart) {
            formData.append(
                'sections',
                cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                cart.renderContents(response);
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            });
    });

    document.querySelectorAll('.qty-select').forEach(button => {
        button.addEventListener('click', function() {
            addProduct(this);
            this.setAttribute('aria-hidden', 'true');
            this.nextElementSibling.setAttribute('aria-hidden', 'false');
        });
    });

    document.querySelector('.bundle-sidebar__main').addEventListener('click', function(event) {
        if (event.target.closest('.remove')) {
            let product = event.target.closest('.bundle-item');
            let productId = product.dataset.id;
            let bundleProduct = document.querySelector(`.bundle-product[data-product-id="${productId}"]`);
            let removableProduct = window.selectedProducts.find(el => el.id === productId);
            if (removableProduct.qty < 2) {
                window.selectedProducts = window.selectedProducts.filter(el => el.id !== productId);
                bundleProduct.querySelector('.bundle-item-qty').setAttribute('aria-hidden', 'true');
                bundleProduct.querySelector('.qty-select').setAttribute('aria-hidden', 'false');
            } else {
                removableProduct.qty -= 1;
                bundleProduct.querySelector('.js-qty__num').value = removableProduct.qty;
            }

            product.remove();
            onProductRemove();
        }
    });


    validateQty = function (qty) {
        if((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    window.addEventListener('resize', function() {
        setSidebarPosition();
    });

    window.addEventListener('scroll', function() {
        bundleSelectionPosition();
    });

    document.querySelectorAll('.bundle-item-qty .js-qty__adjust').forEach(button => {
        button.addEventListener('click', function () {
            let qtyInput = this.parentElement.querySelector('input');
            let qty = parseInt(qtyInput.value);
            let product = this.closest('.bundle-product');
            let productId = product.dataset.productId;

            if (this.classList.contains('js-qty__adjust--plus') && productsAddedTotal < bundleSize) {
                qty += 1;
                addProduct(this);
            } else if (this.classList.contains('js-qty__adjust--minus')) {
                if (qty > 1) {
                    qty -= 1;
                }
                const selectedItems = document.querySelectorAll(`.bundle-item[data-id="${productId}"]`);
                
                let removableItem = selectedItems[selectedItems.length-1];
                let removableProduct = window.selectedProducts.find(el => el.id === productId);
                if (removableProduct.qty < 2) {
                    window.selectedProducts = window.selectedProducts.filter(el => el.id !== productId);
                    product.querySelector('.bundle-item-qty').setAttribute('aria-hidden', 'true');
                    product.querySelector('.qty-select').setAttribute('aria-hidden', 'false');
                } else {
                    removableProduct.qty -= 1;
                }
                removableItem.remove();
                onProductRemove();
            }

            qtyInput.value = qty;

            let itemIndex = window.selectedProducts.findIndex(item => item.id === productId);
            if (window.selectedProducts.length) {
                window.selectedProducts[itemIndex].qty = qty;
            }
        });
    });

    function setSidebarPosition() {
        let sidebar = document.querySelector('.bundle-sidebar');
        let sidebarMain = document.querySelector('.bundle-sidebar__main');
        if (window.innerWidth > 767) {
            sidebarMain.classList.remove('fixed', 'absolute');
            sidebar.style.height = 'auto';
        } else {
            sidebar.style.height = sidebarMain.offsetHeight + 'px';
            sidebarMain.classList.add('fixed');
        }
        bundleSelectionPosition();
    }

    function bundleSelectionPosition() {
        let sidebarMain = document.querySelector('.bundle-sidebar__main');
        let sidebar = document.querySelector('.bundle-sidebar');
        if (window.innerWidth < 768) {
            if (window.scrollY < sidebar.getBoundingClientRect().top + sidebar.offsetHeight - window.innerHeight) {
                sidebarMain.classList.remove('absolute');
                sidebarMain.classList.add('fixed');
            } else {
                sidebarMain.classList.remove('fixed');
                sidebarMain.classList.add('absolute');
            }
        }
    }

    setSidebarPosition();
})();
